import { createSlice } from "@reduxjs/toolkit";
import {
  initialFilter,
  initValuesForecastResult,
} from "../../pages/forecast/ForecastsUIHelpers";

const initialForecastsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  lastError: null,
  objectsData: [],
  queryParams: initialFilter,
  forecastUploadResultDto: { ...initValuesForecastResult },
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const forecastsSlice = createSlice({
  name: "forecasts",
  initialState: initialForecastsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    endCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    // findForecasts
    forecastsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // ObjectsData
    objectsDataFetchedByType: (state, action) => {
      const { objectsData } = action.payload;
      state.error = null;
      state.objectsData = objectsData.map((x) => {
        return { ...x, label: `${x.searchKey} | ${x.objectType}` };
      });
    },
    // Query Params
    updateQueryParams: (state, action) => {
      state.queryParams = action.payload.queryParams;
    },
    updateQueryParamsAndReset: (state, action) => {
      state.queryParams = action.payload.queryParams;
      state.entities = [];
      state.totalCount = 0;
    },
    //Upload
    setForecastUploadResultDto: (state, action) => {
      const { result } = action.payload;
      state.forecastUploadResultDto.success = result.success;
      state.forecastUploadResultDto.message = result.message;
      state.forecastUploadResultDto.fileName = result.fileName;
      state.forecastUploadResultDto.exportRundown = result.exportRundown;
      state.forecastUploadResultDto.typeName = result.typeName;
      state.forecastUploadResultDto.date = result.date;
    },
  },
});
